import React from "react"
import { Link, graphql } from "gatsby"
import { Link as ScrollLink } from "react-scroll"
import { StaticImage } from "gatsby-plugin-image"

import Layout from "../../components/layout"
import PostContentHeader from "../../components/post-content-header"
import PostMainImage from "../../components/post-main-image"
import CategoryDateShare from "../../components/category-date-share"
import Seo from "../../components/seo"
import AuthorContent from "../../components/author-content"
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'

import _ from 'lodash'
import ogImage from "../../images/posts/28/thumb-landscape.jpg"

import Slider from "react-slick";

const Post28 = ({ data: { allCategoryJson, postsJson }, location }) => { 
  const category = _.find(allCategoryJson.edges, (edge) => {
    return edge.node.categoryId === postsJson.categoryId
  }).node

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 3,

    responsive: [
    {
      breakpoint: 1024,
      settings: {
      slidesToShow: 2,
      slidesToScroll: 2,
      }
    },
    {
      breakpoint: 599,
      settings: {
      slidesToShow: 1,
      slidesToScroll: 1,
      }
    }
  ]    
  };

return (
<Layout>
  <Seo title={postsJson.title} description={postsJson.description} ogImage={ogImage} />
  <div className="posts">
    <PostContentHeader categoryName={category.nameJA} postTitle={postsJson.title} location={location} />
    <section id="pickup-article">
      <PostMainImage post={postsJson} />
      <span className="text-center">
        奥から順に<br></br>
        赤：BOTTEGA VENETA／ミニザポーチ／22 x14 x5cm<br></br>
        黒：BOTTEGA VENETA／ミニザポーチ／22 x14 x5cm<br></br>
        左 緑：BOTTEGA VENETA／ミニザバルブ／21 x15 x4cm<br></br>
        右 緑：BOTTEGA VENETA／ミニザポーチ／21 x12 x7cm
      </span>  
      <div className="description wrapper text-two-cloumn">
        <CategoryDateShare category={category} post={postsJson} />
        <div className="title">
          <h1>{postsJson.title}</h1>
          <p>BOTTEGA VENETA（ボッテガ・ヴェネタ）といえば、ブランドの代名詞でもある編みこみレザーのモチーフ、イントレチャート（intrecciato）が印象的ですね。<br></br>イントレチャート（intrecciato）という言葉自体が「編みこみ」を意味する言葉で、BOTTEGA VENETA（ボッテガ・ヴェネタ）で技を極めた職人にしか作れないというほど難しいそうです。<br></br>今回は、そんな魅力が詰まったBOTTEGA VENETA（ボッテガ・ヴェネタ）の人気バッグ10選をご紹介します！

          </p>
        </div>
      </div>
    </section>
    <div className="wrapper">
    <section className="bag-content">
      <div className="text-two-cloumn">
        <h2>目次</h2>
        <p>
          <ScrollLink className="scroll" to="sec1" smooth={true} duration={500} offset={-80}>1.The Pouch（ザ・ポーチ）</ScrollLink><br></br>
          <ScrollLink className="scroll" to="sec2" smooth={true} duration={500} offset={-80}>2.BV TWIST（BVツイスト）</ScrollLink><br></br>
          <ScrollLink className="scroll" to="sec3" smooth={true} duration={500} offset={-80}>3.Cassette（カセット）</ScrollLink><br></br>
          <ScrollLink className="scroll" to="sec4" smooth={true} duration={500} offset={-80}>4.The Arco（ザ・アルコ）</ScrollLink><br></br>
          <ScrollLink className="scroll" to="sec5" smooth={true} duration={500} offset={-80}>5.BV Jodie（ザ・ジョディ）</ScrollLink><br></br>
          <ScrollLink className="scroll" to="sec6" smooth={true} duration={500} offset={-80}>6.Mount（マウント）</ScrollLink><br></br>
          <ScrollLink className="scroll" to="sec7" smooth={true} duration={500} offset={-80}>7.Bulb（バルブ）</ScrollLink><br></br>
          <ScrollLink className="scroll" to="sec8" smooth={true} duration={500} offset={-80}>8.The Shell（ザ・シェル）</ScrollLink><br></br>
          <ScrollLink className="scroll" to="sec9" smooth={true} duration={500} offset={-80}>9.BEAK（ビーク）</ScrollLink><br></br>
          <ScrollLink className="scroll" to="sec10" smooth={true} duration={500} offset={-80}>10.THE POINT（ポイント）</ScrollLink><br></br>
          <ScrollLink className="scroll" to="sec11" smooth={true} duration={500} offset={-80}>11.まとめ</ScrollLink>
        </p>
      </div>               
      <div name="sec1" className="text-max-width">
        <h2>1.The Pouch（ザ・ポーチ）</h2>
      </div>
      <figure>
        <StaticImage src="../../images/posts/28/1.jpg" alt="【最新版】BOTTEGA VENETA（ボッテガ・ヴェネタ）人気バッグ10選！"/>
        <span className="text-center">BOTTEGA VENETA／ザチェーンポーチ／30 x17 x10cm</span>  
      </figure>
      <p>ユニークなフォルムは通称“ギョウザバッグ”として話題に♡<br />The Pouch（ザ・ポーチ）は、ぽてっとしたフォルムを腕に抱えるように持つ姿が新鮮で世界中のセレブを次々と虜に。チャンキーなチェーンが特徴的。
      </p>
      <Slider className="slide-box" {...settings}>
        <div>
          <StaticImage src="../../images/posts/28/2.jpg"/>
          <span className="text-center" style={{padding: "0 5px"}}>BOTTEGA VENETA／ザチェーンポーチ／30 x10 x9cm</span>   
        </div>
        <div>
          <StaticImage src="../../images/posts/28/3.jpg"/>
          <span className="text-center" style={{padding: "0 5px"}}>BOTTEGA VENETA／ザチェーンポーチ／29 x10 x9cm</span>   
        </div>
        <div>
          <StaticImage src="../../images/posts/28/4.jpg"/>
          <span className="text-center" style={{padding: "0 5px"}}>BOTTEGA VENETA／ザチェーンポーチ／30 x10 x10cm</span>   
        </div>
      </Slider>
      <div className="text-max-width">
        <h2>■Mini Pouch（ミニザポーチ）</h2>
        <figure>
          <StaticImage src="../../images/posts/28/5.jpg"/>
          <span className="text-center">BOTTEGA VENETA／ミニザポーチ／21 x12 x7cm</span>   
        </figure>
        <p>ミニサイズは、ショルダー付きでこちらも人気のタイプです。スムースレザーとイントレチャートレザーのタイプがあり、カラー展開も豊富です。</p>
      </div>
      <Slider className="slide-box" {...settings}>
        <div>
          <StaticImage src="../../images/posts/28/6.jpg"/>
          <span className="text-center" style={{padding: "0 5px"}}>BOTTEGA VENETA／ミニザポーチ／22 x14 x5cm</span>   
        </div>
        <div>
          <StaticImage src="../../images/posts/28/7.jpg"/>
          <span className="text-center" style={{padding: "0 5px"}}>BOTTEGA VENETA／ミニザポーチ／20 x12 x5cm</span>   
        </div>
        <div>
          <StaticImage src="../../images/posts/28/8.jpg"/>
          <span className="text-center" style={{padding: "0 5px"}}>BOTTEGA VENETA／ミニザポーチ／22 x12 x5cm</span>   
        </div>
      </Slider>
      <div name="sec2" className="text-max-width">
        <h2>2.BV TWIST（BVツイスト）</h2>
      </div>
      <figure>
        <StaticImage src="../../images/posts/28/9.jpg"/>
        <span className="text-center">BOTTEGA VENETA／BVツイスト／22 x23 x1cm</span>   
      </figure>
      <p>2020春夏に登場した「BVツイスト」（BV Twist）。<br />BOTTEGA VENETA（ボッテガ・ヴェネタ）のアイコンモチーフであるノット（結び目）で作ったハンドルを手首に掛けて持つ、三角形のクラッチバッグ。</p>
      <figure>
        <StaticImage src="../../images/posts/28/10.jpg"/>
        <span className="text-center">BOTTEGA VENETA／BVツイスト／31 x38 x1cm</span>  
      </figure>
      <p>ユニークなフォルムながら、ボッテガらしい上質なナッパレザーを使用した高級感のあるバッグは、底面から荷物を出し入れする斬新なアイテムです。</p>
      <Slider className="slide-box" {...settings}>
        <div>
          <StaticImage src="../../images/posts/28/11.jpg"/>
          <span className="text-center" style={{padding: "0 5px"}}>BOTTEGA VENETA／BVツイスト／22 x23 x1cm</span>  
        </div>
        <div>
          <StaticImage src="../../images/posts/28/12.jpg"/>
          <span className="text-center" style={{padding: "0 5px"}}>BOTTEGA VENETA／BVツイスト／22 x22 x1cm</span>  
        </div>
        <div>
          <StaticImage src="../../images/posts/28/13.jpg"/>
          <span className="text-center" style={{padding: "0 5px"}}>BOTTEGA VENETA／BVツイスト／22 x20 x1cm</span>  
        </div>
      </Slider>
      <div name="sec3" className="text-max-width">
        <h2>3.Cassette（カセット）</h2>
        <p>大人気のCassette（カセット）もいくつか種類があります。</p>
      </div>
      <div className="text-max-width">
        <h2>■Padded Cassette（パデッドカセット）</h2>
        <figure>
          <StaticImage src="../../images/posts/28/14.jpg"/>
          <span className="text-center">BOTTEGA VENETA／パデッドカセット／24 x15 x6cm</span>  
        </figure>
        <p>クラシックカーの内装から着想を得たという、パッド入りのイントレチャートが近未来的。シームレスで接着するハイテク技術と職人技が合わさった逸品です。</p>
        <Slider className="slide-box" {...settings}>
          <div>
            <StaticImage src="../../images/posts/28/15.jpg"/>
            <span className="text-center" style={{padding: "0 5px"}}>BOTTEGA VENETA／パデッドカセット／24 x15 x6cm</span>  
          </div>
          <div>
            <StaticImage src="../../images/posts/28/16.jpg"/>
            <span className="text-center" style={{padding: "0 5px"}}>BOTTEGA VENETA／パデッドカセット／24 x15 x6cm</span>  
          </div>
          <div>
            <StaticImage src="../../images/posts/28/17.jpg"/>
            <span className="text-center" style={{padding: "0 5px"}}>BOTTEGA VENETA／パデッドカセット／24 x15 x5cm</span>  
          </div>
        </Slider>        
      </div>
      <div className="text-max-width">
        <h2>■Padded Tech Cassette（パデッド テック カセット）</h2>
        <figure>
          <StaticImage src="../../images/posts/28/18.jpg"/>
        </figure>
        <p>こちらはナイロンタイプのカセット。<br />バッグ自体はメンズラインですが、もちろんジェンダーレスでお持ちいただけます。丈夫なパッド入りナイロンを用いており、キルティングがまさに今っぽく秋冬スタイルにぴったりのバッグです。</p>
        <figure className="img-small">
          <StaticImage src="../../images/posts/28/19.jpg"/>
          <span className="text-center">BOTTEGA VENETA／パデッドテックカセット／30 x15 x9cm</span>  
        </figure>
      </div>
      <div className="text-max-width">
        <h2>■Cassette（カセット）</h2>
        <figure>
          <StaticImage src="../../images/posts/28/20.jpg"/>
          <span className="text-center">BOTTEGA VENETA／カセット／12 x10 x5cm</span>  
        </figure>
        <p>幅広のグレインレザーを用いており、スッキリとした印象のレザーのカセット。<br />1960年代に考案されたアイコニックなイントレチャートの技法で織り上げたアイテムを、Daniel Lee(ダニエル・リー)が再解釈！上質なナッパレザーを直角に編み上げたデザインは、新鮮でありながらどんなアイテムとも合わせやすい！</p>
        <Slider className="slide-box" {...settings}>
          <div>
            <StaticImage src="../../images/posts/28/21.jpg"/>
            <span className="text-center" style={{padding: "0 5px"}}>BOTTEGA VENETA／カセット／12 x10 x5cm</span> 
          </div>
          <div>
            <StaticImage src="../../images/posts/28/22.jpg"/>
            <span className="text-center" style={{padding: "0 5px"}}>BOTTEGA VENETA／カセット／13 x10 x5cm</span> 
          </div>
          <div>
            <StaticImage src="../../images/posts/28/23.jpg"/>
            <span className="text-center" style={{padding: "0 5px"}}>BOTTEGA VENETA／カセット／21 x14 x5cm</span> 
          </div>
        </Slider>
      </div>
      <div className="text-max-width">
        <h2>■Cassette Bucket（カセット バケットバッグ）</h2>
        <figure>
          <StaticImage src="../../images/posts/28/24.jpg"/>
          <span className="text-center">BOTTEGA VENETA／スモールカセットバケットバッグ／14 x18 x13cm</span> 
        </figure>
        <p>幅広のグレインレザーの「イントレチャート」を使用したバケットバッグ。カジュアルでかわいいバッグです。</p>
        <Slider className="slide-box" {...settings}>
          <div>
            <StaticImage src="../../images/posts/28/25.jpg"/>
            <span className="text-center" style={{padding: "0 5px"}}>BOTTEGA VENETA／スモールカセットバケットバッグ／14 x18 x13cm</span> 
          </div>
          <div>
            <StaticImage src="../../images/posts/28/26.jpg"/>
            <span className="text-center" style={{padding: "0 5px"}}>BOTTEGA VENETA／カセット／9 x14 x9cm</span> 
          </div>
          <div>
            <StaticImage src="../../images/posts/28/27.jpg"/>
            <span className="text-center" style={{padding: "0 5px"}}>BOTTEGA VENETA／カセット／9 x13 x9cm</span> 
          </div>
        </Slider>
      </div>
      <div name="sec4" className="text-max-width">
        <h2>4.The Arco（ザ・アルコ）</h2>
      </div>
      <figure>
        <StaticImage src="../../images/posts/28/28.jpg"/>
        <span className="text-center">
          左から<br></br>
          BOTTEGA VENETA／スモールザアルコ／22 x16 x9cm<br></br>
          BOTTEGA VENETA／スモールザアルコ／22 x17 x8cm
        </span> 
      </figure>
      <p>ミラノの中心に建てられた凱旋門「アルコ・デッラ・パーチェ（平和の門）」をイメージしたボッテガのニューアイコン「ザ・アルコ」。<br />BOTTEGA VENETA（ボッテガ・ヴェネタ）の新たなアイコンバッグとして注目されています。</p>
      <div className="text-max-width">
        <h2>■スモールザアルコ /22x16x9cm（幅x高さxマチ）</h2>
        <Slider className="slide-box" {...settings}>
          <div>
            <StaticImage src="../../images/posts/28/29.jpg"/>
            <span className="text-center" style={{padding: "0 5px"}}>BOTTEGA VENETA／スモールザアルコ／22 x16 x9cm</span> 
          </div>
          <div>
            <StaticImage src="../../images/posts/28/30.jpg"/>
            <span className="text-center" style={{padding: "0 5px"}}>BOTTEGA VENETA／スモールザアルコ／22 x17 x8cm</span> 
          </div>
          <div>
            <StaticImage src="../../images/posts/28/31.jpg"/>
            <span className="text-center" style={{padding: "0 5px"}}>BOTTEGA VENETA／スモールザアルコ／22 x17 x9cm</span> 
          </div>
        </Slider>        
      </div>
      <div className="text-max-width">
        <h2>■ミニザアルコ /18x14x8cm（幅x高さxマチ）</h2>
        <Slider className="slide-box" {...settings}>
          <div>
            <StaticImage src="../../images/posts/28/32.jpg"/>
            <span className="text-center" style={{padding: "0 5px"}}>BOTTEGA VENETA／ミニザアルコ／18 x14 x8cm</span> 
          </div>
          <div>
            <StaticImage src="../../images/posts/28/33.jpg"/>
            <span className="text-center" style={{padding: "0 5px"}}>BOTTEGA VENETA／ミニザアルコ／17 x13 x8cm</span> 
          </div>
          <div>
            <StaticImage src="../../images/posts/28/34.jpg"/>
            <span className="text-center" style={{padding: "0 5px"}}>BOTTEGA VENETA／ミニザアルコ／18 x16 x9cm</span> 
          </div>
        </Slider>
      </div>
      <div name="sec5" className="text-max-width">
        <h2>5.BV Jodie（ザ・ジョディ）</h2>
      </div>
      <figure>
        <StaticImage src="../../images/posts/28/35.jpg"/>
        <span className="text-center">BOTTEGA VENETA／ミニザジョディ／20 x16 x3cm</span> 
      </figure>
      <p>Jodie Foster（ジョディ・フォスター）がパパラッチから身を隠すために使っていたことから名付けられたことで有名な「Jodie（ジョディ）」。<br />イントレチャートを全面に配したボッテガらしいバッグです。</p>
      <Slider className="slide-box" {...settings}>
        <div>
          <StaticImage src="../../images/posts/28/36.jpg"/>
          <span className="text-center" style={{padding: "0 5px"}}>BOTTEGA VENETA／ミニザジョディ／20 x16 x3cm</span> 
        </div>
        <div>
          <StaticImage src="../../images/posts/28/37.jpg"/>
          <span className="text-center" style={{padding: "0 5px"}}>BOTTEGA VENETA／ミニザジョディ／20 x14 x3cm</span> 
        </div>
        <div>
          <StaticImage src="../../images/posts/28/38.jpg"/>
          <span className="text-center" style={{padding: "0 5px"}}>BOTTEGA VENETA／ミニザジョディ／20 x14 x3cm</span> 
        </div>
      </Slider>
      <Link to="https://laxus.co/app/pc/bags/bottega_veneta" className="view-all-button">
       ボッテガ・ヴェネタのバッグを見る
      </Link>      
      <div name="sec6" className="text-max-width">
        <h2>6.Mount（マウント）</h2>
      </div>
      <figure>
        <StaticImage src="../../images/posts/28/39.jpg"/>
      </figure>
      <p>チャンキーなチェーンがあしらわれたデザインが特徴のMount（マウント）。<br />コンパクトなショルダータイプはシャープな三角シルエットのフラップがポイントです。ストラップは長さ調節可能なので、ショルダーとしても、クロスボディバッグとしても。</p>
      <figure className="img-small">
        <StaticImage src="../../images/posts/28/40.jpg"/>
        <span className="text-center">BOTTEGA VENETA／マウント／20 x14 x3cm</span> 
      </figure>
      <div name="sec7" className="text-max-width">
        <h2>7.Bulb（バルブ）</h2>
      </div>
      <figure>
        <StaticImage src="../../images/posts/28/41.jpg"/>
        <span className="text-center">BOTTEGA VENETA／ミニザバルブ／21 x15 x4cm</span> 
      </figure>
      <p>底のプリーツで丸みを出したシルエットが特徴的な「ミニ ザ・バルブ」。<br />ノット付レザーストラップにアイコニックなイントレチャートの編み込みでボリューム感のあるバッグです。</p>
      <div className="img-two-cloumn">
        <figure className="img-small">
          <StaticImage src="../../images/posts/28/42.jpg"/>
          <span className="text-center">BOTTEGA VENETA／ミニザバルブ／21 x15 x4cm</span> 
        </figure>
        <figure className="img-small">
          <StaticImage src="../../images/posts/28/43.jpg"/>
          <span className="text-center">BOTTEGA VENETA／ミニザバルブ／21 x15 x5cm</span> 
        </figure>
      </div>
      <div name="sec8" className="text-max-width">
        <h2>8.The Shell（ザ・シェル）</h2>
      </div>
      <figure>
        <StaticImage src="../../images/posts/28/44.jpg"/>
      </figure>
      <p>2021年に登場の「シェルバッグ」。<br />カラフルなカラー展開と名前のとおり、貝殻（シェル）をイメージしてつくられたバッグ。主に春夏のコーデに合わせたいバッグですね！レザーを使用したパネルに同色ポーチもついているのでバッグの収納力も◎</p>
      <figure className="img-small">
        <StaticImage src="../../images/posts/28/45.jpg"/>
        <span className="text-center">BOTTEGA VENETA／ザシェル／17 x13 x5cm</span> 
      </figure>
      <div name="sec9" className="text-max-width">
        <h2>9.BEAK(ビーク)</h2>
      </div>
      <figure className="img-small">
        <StaticImage src="../../images/posts/28/46.jpg"/>
        <span className="text-center">BOTTEGA VENETA／ビーク／18 x24 x13cm</span> 
      </figure>
      <p>コロンとしたフォルムのショルダーバッグで、トライアングルフラップが特徴的な「BEAK（ビーク）」。<br />マグネットとドローストリングによる開閉式のコンパートメントはマチもしっかりあり、使いやすいバッグです。</p>
      <div name="sec10" className="text-max-width">
        <h2>10.THE POINT（ポイント）</h2>
      </div>
      <figure>
        <StaticImage src="../../images/posts/28/47.jpg"/>
      </figure>
      <p>逆三角形のトップハンドルがスタイリッシュな「POINT（ポイント）」。<br />レザーや、マクラメ、ナイロンなどさまざまなタイプが発売されています。ショルダーストラップ付きで、2wayでの使用が可能です。</p>
      <figure>
        <StaticImage src="../../images/posts/28/48.jpg"/>
      </figure>
      <p>斜めがけでも、ショルダーでも◎使いやすいバッグです。</p>
      <figure className="img-small">
        <StaticImage src="../../images/posts/28/49.jpg"/>
        <span className="text-center">BOTTEGA VENETA／スモールポイント／20 x17 x7cm</span> 
      </figure>                                      
      <div name="sec11" className="text-two-cloumn">
        <h2>11.まとめ</h2>
        <p>いかがでしたでしょうか？構築的なデザインや、アイキャッチなカラーバリエもBOTTEGA VENETA（ボッテガ・ヴェネタ）の人気の理由。まずはアプリでチェックしてみてませんか？
        </p>
      </div>
      <Link to="https://laxus.co/app/pc/bags/bottega_veneta" className="view-all-button">
       ボッテガ・ヴェネタのバッグを見る
      </Link>  
    </section>
    <AuthorContent authorId={postsJson.authorId} />
    </div>
  </div>
</Layout>
)}

export default Post28

export const pageQuery = graphql`
  query {
    postsJson(postId: {eq: 28}) {
      id
      title
      postId
      postedAt
      description
      categoryId
      authorId      
      thumbnailSquare {
        src {
          childImageSharp {
            gatsbyImageData
          }
        }
      }
      thumbnailLandscape {
        src {
          childImageSharp {
            gatsbyImageData
          }
        }
      }
    }
    allCategoryJson(sort: {fields: sortOrder}) {
      edges {
        node {
          id
          categoryId
          slug
          nameJA
          nameEN
          description
        }
      }
    }
  }
`
